import { render } from "./tatakelola.vue?vue&type=template&id=35e52d06&scoped=true"
import script from "./tatakelola.vue?vue&type=script&lang=js"
export * from "./tatakelola.vue?vue&type=script&lang=js"

import "./tatakelola.vue?vue&type=style&index=0&id=35e52d06&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e52d06"]])

export default __exports__